import React from 'react';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { defineMessages, FormattedMessage } from 'react-intl';

import TooltipMessage from '../../../components/shipment-status-icon/tooltip-message/index';
import TooltipError from '../../../components/shipment-status-icon/tooltip-error/index';

import style from '../shipment-status.module.less';

const messages = defineMessages({
  notifications: {
    description: 'shipment-status.notifications',
    defaultMessage: 'Notifications',
    id: 'bUkR7Q',
  },
  sent: {
    description: 'shipment-status.sent',
    defaultMessage: 'Sent',
    id: 'D4NkPH',
  },
  marketplaceNotificationFailed: {
    description: 'shipment-status.marketplaceNotificationFailed',
    defaultMessage: 'Marketplace Notification Failed',
    id: 'V0X6Cp',
  },
  marketplaceNotificationSent: {
    description: 'shipment-status.marketplaceNotificationSent',
    defaultMessage: 'Marketplace Notified',
    id: 'xRqd+e',
  },
  deliveryEmailNotificationSent: {
    description: 'shipment-status.deliveryEmailNotificationSent',
    defaultMessage: 'Delivery Email Sent',
    id: 'IlU7sr',
  },
  deliveryEmailNotificationFailed: {
    description: 'shipment-status.deliveryEmailNotificationFailed',
    defaultMessage: 'Delivery Email Failed',
    id: 'w9Zx5a',
  },
  shipmentEmailNotificationSent: {
    description: 'shipment-status.shipmentEmailNotificationSent',
    defaultMessage: 'Shipment Email Sent',
    id: '1CSf/n',
  },
  shipmentEmailNotificationFailed: {
    description: 'shipment-status.shipmentEmailNotificationFailed',
    defaultMessage: 'Shipment Email Failed',
    id: 'CjhHXo',
  },
});

const buildFailedNotificationTooltip = (key, data) => (
  <TooltipError key={key} content={data.errorMessage} title={<FormattedMessage {...messages[`${key}Failed`]} />} />
);

const buildSentNotificationTooltip = (key) => {
  return <TooltipMessage key={key} singleMessage={messages[`${key}Sent`]} />;
};

const determineNotificationStatus = (sent, errored) => {
  if (errored.length) {
    return 'error';
  }
  if (sent.length) {
    return 'completed';
  }
  return '';
};

const notoSuccessTypes = ['Sent', 'Notified'];

export default {
  id: 'notifications',
  generateProps: ({ marketplaceNotification, shipmentEmailNotification, deliveryEmailNotification }) => {
    const notifications = {
      marketplaceNotification,
      shipmentEmailNotification,
      deliveryEmailNotification,
    };

    const tooltips = Object.keys(notifications)
      .filter((notificationKey) => notificationKey)
      .reduce(
        (built, notificationKey) => {
          const data = notifications[notificationKey];
          if (data) {
            if (data.errorMessage) {
              built.errored.push(buildFailedNotificationTooltip(notificationKey, data));
            }
            if (notoSuccessTypes.includes(data.status)) {
              built.sent.push(buildSentNotificationTooltip(notificationKey));
            }
          }
          return built;
        },
        {
          sent: [],
          errored: [],
        },
      );
    const { sent, errored } = tooltips;
    const status = determineNotificationStatus(sent, errored);
    const haveDataForStatus = status.length;

    return {
      title: <FormattedMessage {...messages.notifications} />,
      status,
      icon: faPaperPlane,
      // Any falsey value passed to message will result in the default em-dash being renderd in the component
      message: haveDataForStatus ? <FormattedMessage {...messages.sent} /> : undefined,
      tooltipContent: haveDataForStatus ? sent.concat(errored) : undefined,
      key: 'notifications',
      iconStyle: style['plane-icon'],
    };
  },
};
